import useDetectMobile from "./useDetectMobile";

const useAssistantPanelAvailable = () => {
  const isMobile = useDetectMobile();

  return !isMobile;
};

export default useAssistantPanelAvailable;
